import PropTypes from 'prop-types';
import React from 'react';
import usStateCodes from 'us-state-codes';
import classNames from 'classnames';

/**
 * Displays hospital penalties filters
 */
export default class PenaltiesFilters extends React.PureComponent {

  /**
   * @returns {object} - JSX for the component.
   */
  render() {
    const {
      activePenalty,
      activeSearch,
      activeState,
      onFilter,
      onResetFilters,
      states,
    } = this.props;

    return (
      <div className="hospitalPenalties-filters">
        <div className="filter-row right">
          <button
            className="filter--reset"
            onClick={() => onResetFilters()}
          >
            Reset all filters
          </button>
        </div>
        <div className="filter-row">
          <div className="filter filter--state">
            <label htmlFor="state-select">State</label>
            <select
              id="state-select"
              value={activeState ?
                usStateCodes.getStateNameByStateCode(activeState) : 'all'}
              onChange={(event) =>
                onFilter('activeState', 'all' === event.target.value ?
                event.target.value :
                usStateCodes.getStateCodeByStateName(event.target.value))
              }
            >
              <option value="all">All states</option>
              {states.map((optState) => (
                <option
                  key={optState}
                >
                  {usStateCodes.getStateNameByStateCode(optState)}
                </option>
              ))}
            </select>
          </div>
          <div className="filter filter--search">
            <label htmlFor="search-select">Search</label>
            <input
              id="search-select"
              type="text"
              placeholder="Hospital, city, county, state..."
              value={activeSearch || ''}
              onChange={(event) =>
                onFilter('activeSearch', event.target.value)}
            />
          </div>
        </div>
        <div className="filter-row fill">
          <button
            aria-label="Display readmission rate penalties in table"
            className={classNames(
              { 'table-button': true,
                active: 'readmission' === activePenalty })}
            onClick={() => onFilter(
              'activePenalty', 'readmission')}
          >
            Readmission
          </button>
          <button
            aria-label="Display hospital-acquired conditions penalties in table"
            className={classNames(
              { 'table-button': true,
                active: 'hac' === activePenalty })}
            onClick={() => onFilter('activePenalty', 'hac')}
          >
            Hospital-Acquired Conditions
          </button>
        </div>
        <div className="penalty-description">
          {'hac' === activePenalty ?
            '"Yes" means payments are reduced 1 percent because of high rates of complications.' : // eslint-disable-line max-len
            'Percentage by which payments are reduced because of excess rehospitalizations.' // eslint-disable-line max-len
          }
        </div>
      </div>
    );
  }
}

PenaltiesFilters.propTypes = {
  activePenalty: PropTypes.string.isRequired,
  activeState: PropTypes.string,
  activeSearch: PropTypes.string,
  onFilter: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  states: PropTypes.instanceOf(Array).isRequired,
};

PenaltiesFilters.defaultProps = {
  activeSearch: null,
  activeState: null,
};
